import {
  AppBar,
  Box,
  CssBaseline,
  Divider,
  IconButton,
  Toolbar,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  Collapse,
  Drawer,
  Typography,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { getUser } from '../../../redux/usersRedux';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { IMGS_URL } from '../../../config';

const drawerWidth = 240;
// const pz05Setting = [
//   {
//     href: '/pz05',
//     label: 'Lista niezgodności PZ05',
//   },
//   {
//     href: 'add-pz05',
//     label: 'Dodaj niezgodność PZ05',
//   },
//   {
//     href: '/pz05/raport',
//     label: 'Raport PZ05',
//   },
// ];

// const masterSetting = [
//   {
//     label: 'Piwo',
//     subSetting: [
//       { href: '/marka', label: 'Marka' },
//       { href: '/opakowanie', label: 'Opakowanie' },
//       { href: '/beer', label: 'Lista piw' },
//     ],
//   },
//   {
//     label: 'Niezgodności',
//     subSetting: [
//       { href: '/pochodzenie', label: 'Pochodzenie' },
//       { href: '/obszar', label: 'Obszar' },
//       { href: '/rodzaj', label: 'Rodzaj' },
//       { href: '/opis', label: 'Opis' },
//       { href: '/dodatkowy-opis', label: 'Dodatkowy opis' },
//       { href: '/przyczyny', label: 'Przyczyny niezgodności' },
//     ],
//   },
// ];
// const userSettings = [
//   { href: '/account', label: {t('account.description')} },
//   { href: '/users', label: 'Użytkownicy' },
//   { href: '/logout', label: 'Wyloguj' },
// ];

const lngs = {
  en: { nativeName: 'EN', flag: '🇬🇧' },
  pl: { nativeName: 'PL', flag: '🇵🇱' },
};

function ResponsiveDrawer({ children }, props) {
  const { t, i18n } = useTranslation();
  const { window } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [subOpen, setSubOpen] = useState(false);
  const [beerOpen, setBeerOpen] = useState(false);
  const [binOpen, setBinOpen] = useState(false);
  const [specificationOpen, setSpecificationOpen] = useState(false);
  const [userOpen, setUserOpen] = useState(false);
  const [rejestrOpen, setRejestrOpen] = useState(false);
  const [rejestrPZ04Open, setRejestrPZ04Open] = useState(false);
  const user = useSelector((state) => getUser(state));
  const navigate = useNavigate();
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const [choosen, setChoosen] = useState(false);
  const [mailingOpen, setMailingOpen] = useState(false);

  const userSettings = [
    { href: '/account', label: `${t('account.description')}` },
    { href: '/users', label: `${t('account.users')}` },
    { href: '/logout', label: `${t('account.logout')}` },
  ];

  const masterSetting = [
    {
      label: `${t('masterData.descriptionBeer')}`,
      subSetting: [
        { href: '/marka', label: `${t('masterData.brand')}` },
        { href: '/opakowanie', label: `${t('masterData.packages')}` },
        { href: '/beer', label: `${t('masterData.beerList')}` },
      ],
    },
    {
      label: `${t('masterData.desIncompatibilities')}`,
      subSetting: [
        { href: '/pochodzenie', label: `${t('masterData.origins')}` },
        { href: '/obszar', label: `${t('masterData.area')}` },
        { href: '/rodzaj', label: `${t('masterData.type')}` },
        { href: '/opis', label: `${t('masterData.description')}` },
        { href: '/dodatkowy-opis', label: `${t('masterData.additionalDes')}` },
        { href: '/przyczyny', label: `${t('masterData.reasons')}` },
      ],
    },
    {
      label: `${t('masterData.specification.title')}`,
      subSetting: [
        {
          href: '/specifications',
          label: `${t('masterData.specification.specificationList')}`,
        },
      ],
    },
    {
      label: `${t('masterData.mailing')}`,
      subSetting: [
        { href: '/odbiorcy', label: `${t('masterData.recipients')}` },
        { href: '/mailing-group', label: `${t('masterData.mailingGroup')}` },
      ],
    },
    {
      label: `${t('bins.bin')}`,
      subSetting: [{ href: '/bins', label: `${t('bins.binList')}` }],
    },
  ];

  const pz05Setting = [
    {
      href: '/pz05',
      label: `${t('pz05.listIncompatibilities')}`,
    },
    {
      href: 'add-pz05',
      label: `${t('pz05.addIncompatibility')}`,
    },
    {
      href: '/pz05/raport',
      label: `${t('pz05.reportPZ05')}`,
    },
  ];

  const pz04Setting = [
    {
      href: '/pz04',
      label: `${t('pz04.listIncompatibilities')}`,
    },
    {
      href: 'add-pz04',
      label: `${t('pz04.addIncompatibility')}`,
    },
    {
      href: '/pz04/raport',
      label: `${t('pz04.reportPZ04')}`,
    },
  ];

  const handleOpen = () => {
    setOpen(!open);
  };

  const handleSubOpen = (rodzaj) => {
    if (rodzaj === `${t('masterData.descriptionBeer')}`) {
      setBeerOpen(!beerOpen);
    } else if (rodzaj === `${t('masterData.desIncompatibilities')}`) {
      setSubOpen(!subOpen);
    } else if (rodzaj === `${t('bins.bin')}`) {
      setBinOpen(!binOpen);
    } else if (rodzaj === `${t('masterData.specification.title')}`) {
      setSpecificationOpen(!specificationOpen);
    } else if (rodzaj === `${t('masterData.mailing')}`) {
      setMailingOpen(!mailingOpen);
    }
  };

  const handleMobileMenuOpen = () => {
    setUserOpen(!userOpen);
  };

  const handleRejestrOpen = () => {
    setRejestrOpen(!rejestrOpen);
  };

  const handleRejestrPZ04Open = () => {
    setRejestrPZ04Open(!rejestrPZ04Open);
  };

  const handleAction = (action) => {
    navigate(action);
  };

  const drawer = (
    <div style={{ background: '#C09A53 ', color: 'white' }}>
      <Toolbar>
        <Box
          sx={{
            display: { xs: 'flex', md: 'flex' },
            mr: 1,
            width: '100px',
            height: '100%',
          }}
        >
          <Box
            component="img"
            src={`${IMGS_URL}/logo.png`}
            alt="logo"
            sx={{ maxHeight: '100%', maxWidth: '100%' }}
          />
          <Box
            component="img"
            src={`${IMGS_URL}/AMBF_LOGO.png`}
            alt="logo"
            sx={{ maxHeight: '70%', maxWidth: '70%', ml: 1, cursor: 'pointer' }}
            onClick={() => handleAction('/')}
          />
        </Box>
        {/* <Typography sx={{ mt: 1, fontWeight: 700, fontSize: '25px' }}>
          AMBF
        </Typography> */}
      </Toolbar>
      <Divider />
      <List>
        <ListItem disablePadding>
          <ListItemButton onClick={() => handleAction('/')}>
            Home
          </ListItemButton>
        </ListItem>
        {user.users !== null &&
          (user.users.role === 'KONTROLER' || user.users.role === 'ADMIN') && (
            <>
              <ListItem disablePadding>
                <ListItemButton onClick={() => handleAction('/slider')}>
                  Slider
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding>
                <ListItemButton onClick={() => handleAction('/dashboard')}>
                  Dashboard
                </ListItemButton>
              </ListItem>
            </>
          )}
        {user.users !== null &&
          (user.users.role === 'KONTROLER' ||
            user.users.role === 'ADMIN' ||
            user.users.role === 'KIER_ODC_BWH' ||
            user.users.role === 'MISTRZ_ZMIANY') && (
            <>
              <ListItem disablePadding>
                <ListItemButton
                  onClick={() => handleAction('/inventory-counting')}
                >
                  Liczenie kroczące
                </ListItemButton>
              </ListItem>
            </>
          )}
        {user.users !== null &&
          (user.users.role === 'ADMIN' ||
            user.users.role === 'KIER_ODC_BWH' ||
            user.users.role === 'MISTRZ_ZMIANY' ||
            user.users.role === 'STARSZY_MAGAZYNIER' ||
            user.users.role === 'KONTROLER') && (
            <>
              <ListItem disablePadding>
                <ListItemButton
                  onClick={() => handleAction('/production-handover')}
                >
                  Przekazanie produkcji
                </ListItemButton>
              </ListItem>
            </>
          )}
        {user.users !== null &&
          user.users.role !== 'ROZLEW' &&
          user.users.role !== 'LABO' &&
          user.users.role !== 'STARSZY_MAGAZYNIER' &&
          user.users.role !== 'OPERATOR' && (
            <>
              <ListItem disablePadding>
                <ListItemButton onClick={handleRejestrOpen}>
                  {t('pz05.description')}
                  {rejestrOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </ListItem>
              <Collapse in={rejestrOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {pz05Setting &&
                    pz05Setting.map((el) => {
                      if (
                        user.users.role === 'ADMIN' ||
                        user.users.role === 'KONTROLER' ||
                        el.label === `${t('pz05.listIncompatibilities')}` ||
                        el.label === `${t('pz05.reportPZ05')}`
                      ) {
                        return (
                          <ListItemButton
                            key={el.label}
                            sx={{ pl: 4 }}
                            onClick={() => handleAction(el.href)}
                          >
                            <ListItemText primary={el.label} />
                          </ListItemButton>
                        );
                      }
                    })}
                </List>
              </Collapse>
            </>
          )}

        {/* Rejestr PZ04 */}
        {user.users !== null &&
          (user.users.role === 'KONTROLER' ||
            user.users.role === 'LABO' ||
            user.users.role === 'ADMIN') && (
            <>
              <ListItem disablePadding>
                <ListItemButton onClick={handleRejestrPZ04Open}>
                  {t('pz04.description')}
                  {rejestrPZ04Open ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </ListItem>
              <Collapse in={rejestrPZ04Open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {pz04Setting &&
                    pz04Setting.map((el) => {
                      if (
                        user.users.role === 'ADMIN' ||
                        (user.users.role === 'LABO' &&
                          el.label === `${t('pz04.addIncompatibility')}`) ||
                        (user.users.role === 'LABO' &&
                          el.label === `${t('pz04.reportPZ04')}`) ||
                        el.label === `${t('pz04.listIncompatibilities')}`
                      ) {
                        return (
                          <ListItemButton
                            key={el.label}
                            sx={{ pl: 4 }}
                            onClick={() => handleAction(el.href)}
                          >
                            <ListItemText primary={el.label} />
                          </ListItemButton>
                        );
                      }
                    })}
                </List>
              </Collapse>
            </>
          )}

        {/* Koniec rejestru pz04 */}
        {user.users !== null &&
          (user.users.role === 'ADMIN' ||
            user.users.role === 'KIER_DS_REKLAMACJI' ||
            user.users.role === 'KONTROLER') && (
            <>
              <ListItem disablePadding>
                <ListItemButton onClick={handleOpen}>
                  MasterData {open ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </ListItem>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {masterSetting.map((el) => {
                    if (
                      user.users.role === 'ADMIN' ||
                      ((user.users.role === 'ADMIN' ||
                        user.users.role === 'KONTROLER') &&
                        el.label === `${t('masterData.descriptionBeer')}`) ||
                      el.label === `${t('masterData.desIncompatibilities')}` ||
                      ((user.users.role === 'ADMIN' ||
                        user.users.role === 'KONTROLER') &&
                        el.label === `${t('bins.bin')}`)
                    ) {
                      return (
                        <>
                          <ListItemButton
                            key={el.label}
                            sx={{ pl: 4 }}
                            onClick={() => handleSubOpen(el.label)}
                          >
                            <ListItemText primary={el.label} />
                            {(
                              el.label === `${t('masterData.descriptionBeer')}`
                                ? beerOpen
                                : el.label ===
                                  `${t('masterData.desIncompatibilities')}`
                                ? subOpen
                                : el.label === `${t('bins.bin')}`
                                ? binOpen
                                : el.label === `${t('masterData.mailing')}`
                                ? mailingOpen
                                : specificationOpen
                            ) ? (
                              <ExpandLess />
                            ) : (
                              <ExpandMore />
                            )}
                          </ListItemButton>

                          {el.subSetting && (
                            <Collapse
                              in={
                                el.label ===
                                `${t('masterData.descriptionBeer')}`
                                  ? beerOpen
                                  : el.label ===
                                    `${t('masterData.desIncompatibilities')}`
                                  ? subOpen
                                  : el.label === `${t('bins.bin')}`
                                  ? binOpen
                                  : el.label === `${t('masterData.mailing')}`
                                  ? mailingOpen
                                  : specificationOpen
                              }
                              timeout="auto"
                              unmountOnExit
                            >
                              <List component="div" disablePadding>
                                {el.subSetting.map((subEl) => {
                                  if (
                                    user.users.role === 'ADMIN' ||
                                    subEl.label ===
                                      `${t('masterData.beerList')}` ||
                                    subEl.label ===
                                      `${t('masterData.reasons')}` ||
                                    subEl.label === `${t('bins.binList')}`
                                  ) {
                                    return (
                                      <ListItemButton
                                        key={subEl.label}
                                        sx={{
                                          pl: 8,
                                        }}
                                        onClick={() => handleAction(subEl.href)}
                                      >
                                        <ListItemText primary={subEl.label} />
                                      </ListItemButton>
                                    );
                                  }
                                })}
                              </List>
                            </Collapse>
                          )}
                        </>
                      );
                    }
                  })}
                </List>
              </Collapse>
            </>
          )}
        {user.users !== null && (
          <>
            <ListItem disablePadding>
              <ListItemButton onClick={handleMobileMenuOpen}>
                {`${user.users.firstName} ${user.users.lastName}`}
                {userOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
            </ListItem>
            <Collapse in={userOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {userSettings &&
                  userSettings.map((el) => {
                    if (
                      user.users.role === 'ADMIN' ||
                      el.label === `${t('account.description')}` ||
                      el.label === `${t('account.logout')}`
                    ) {
                      return (
                        <ListItemButton
                          key={el.label}
                          sx={{ pl: 4 }}
                          onClick={() => handleAction(el.href)}
                        >
                          <ListItemText primary={el.label} />
                        </ListItemButton>
                      );
                    }
                  })}
              </List>
            </Collapse>
          </>
        )}
      </List>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
        }}
        onClick={() => setChoosen(!choosen)}
      >
        <div
          style={{
            height: '60px',
            position: 'relative',
            width: '144px',
          }}
        >
          {Object.keys(lngs).map((lng) => (
            <button
              key={lng}
              style={{
                cursor: 'pointer',
                display: 'block',
                height: '40px',
                position: 'absolute',
                opacity: choosen || i18n.resolvedLanguage === lng ? '1' : '0',
                zIndex: i18n.resolvedLanguage === lng ? '1' : '0',
                left:
                  lng === 'en' && choosen
                    ? '12px'
                    : lng === 'pl' && choosen
                    ? '60px'
                    : '48px',
                top: choosen ? '10px' : '0',

                transition: '0.76s',
                width: '40px',
                webkitTransition: '0.76s',
                background: 'transparent',
                border: 'none',
                fontSize: '40px',
              }}
              type="submit"
              onClick={() => i18n.changeLanguage(lng)}
            >
              {lngs[lng].flag}
            </button>
          ))}
        </div>
      </div>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  if (user.users === null) {
    return (
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          margin: 'auto',
          width: {
            sm: `calc(100% - ${drawerWidth}px)`,
            md: '90%',
            lg: '90%',
            xl: '90%',
          },
        }}
      >
        <Toolbar />
        {children}
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
      >
        {/* tutaj dodalem display none dla md */}
        <Toolbar
          sx={{ bgcolor: '#C09A53', display: { xs: 'flex', md: 'none' } }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mt: 2, mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <Box
            sx={{
              display: { xs: 'flex', md: 'none' },
              mt: 2,
              mr: 1,
              width: '100px',
              height: '100%',
            }}
          >
            <Box
              component="img"
              src={`${IMGS_URL}/logo.png`}
              alt="logo"
              sx={{ maxHeight: '100%', maxWidth: '100%' }}
            />
          </Box>
          <Typography
            sx={{ display: { xs: 'block', md: 'none' }, mt: 3 }}
            variant="h6"
            noWrap
            component="div"
          >
            AMBF
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="div"
        sx={{
          flexGrow: 1,
          m: 'auto',
          p: 3,
          width: {
            sm: `calc(100% - ${drawerWidth}px)`,
            md: '90%',
            lg: '90%',
            xl: '90%',
          },
          // maxWidth: '100vw',
        }}
      >
        <Toolbar />

        {children}
      </Box>
    </Box>
  );
}

export default ResponsiveDrawer;
